export default "__VITE_ASSET__99ef9e5f__"